import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from 'lucide-react';

export default function EstimationStep2({ formData, errors, updateFormData, onNext, onBack }) {
  return (
    <div data-testid="estimation-step-2">
      <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-6">
        Capacité d'accueil
      </h2>

      <div className="space-y-6">
        <div>
          <Label htmlFor="capacity">Nombre de voyageurs *</Label>
          <Input
            id="capacity"
            type="number"
            min="1"
            value={formData.capacity}
            onChange={(e) => updateFormData('capacity', e.target.value)}
            placeholder="Ex: 4"
            data-testid="estimation-capacity"
          />
          {errors.capacity && <p className="text-sm text-red-500 mt-1">{errors.capacity}</p>}
        </div>
      </div>

      <div className="flex gap-4 mt-8">
        <Button
          onClick={onBack}
          variant="outline"
          className="flex-1"
          data-testid="estimation-back-2"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour
        </Button>
        <Button
          onClick={onNext}
          className="flex-1 bg-[#8A9474] hover:bg-[#7A8464] text-white"
          data-testid="estimation-next-2"
        >
          Continuer <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
